import { EnRptType } from '@medlogic/shared/shared-interfaces';
export interface IUrl {
  title: string;
  url: string;
  enRptType?: EnRptType;
}
